import React, { useEffect } from 'react';
import Loadable from '@loadable/component'
import _ from 'lodash';
import GlobalActions from 'stores/global/actions';
import { useSelector, useDispatch } from 'react-redux';
import Languages from 'locales';
import RoutesConfig from 'router';
import {IntlProvider} from 'react-intl';
// import { useParams } from "react-router-dom";
import ReactRouterContext from 'contexts/ReactRouterContext'
import { Dialog, Alert, Snackbar } from 'lbComponents';
const RouteComponents:any = {};

const LoadableComponent = (props:any) => {
  const {SkeletonLoading} = props;
  // const routeParams: {lang?:string} = useParams();

  const global = useSelector( (state:any) => state.global);
  const [i18nMessages, setI18nMessages] = React.useState<any>({});
  const [modulesSetting, setModulesSetting] = React.useState<any>({});
  
  const dispatch = useDispatch();
  const setRouteComponents = (route:any) => {
    RouteComponents[route.component] = Loadable(() => import(`pages/${route.component}`),{
      fallback: <SkeletonLoading/>
    });
    if(route.routes && route.routes.length) {
      route.routes.map((child:any) => { setRouteComponents(child)})
    }
  }

  useEffect(() => {
    const messages:any = {};
    let modulesConfig:any = {}

    props.routes.map((route:any) => {
      setRouteComponents(route);
    });
    
    if(!global.languageSettings.isInitial) {
      const paramsLang:string = props.location.pathname.split('/').filter((val:string,index:number) => val && index<=1 )[0] || ''
      const userLangKey = _.findKey(Languages, function(lang:any) { 
        const keys = lang.keys.split('|');
        return keys.indexOf(paramsLang || 'zh_tw') >= 0
      });
      dispatch(GlobalActions.changeLanguage({locale: userLangKey || Object.keys(Languages)[0]}))
    }

    Object.keys(Languages).map((lang:string) => {
      messages[lang] = Languages[lang].messages;
    });

    const getBlockMessage = (blockName:string, locale:string) => {
      try {
        const message:any = require(`locales/${blockName}/${locale}`);
        return new Promise((resolve,reject) => {
          resolve({
            ...message
          })
        })
      } catch (error) {
        return new Promise((resolve,reject) => {
          resolve({})
        })
      }
    }

    const getModulesConfig = (moduleName:string) => {
      try {
        const moduleConfig:any = require(`config/${moduleName}/config.json`) || {};
        const config:any = moduleConfig[moduleName] || {};
        return new Promise((resolve,reject) => {
          resolve({
            [moduleName]: config
          })
        })
      } catch (error) {
        return new Promise((resolve,reject) => {
          resolve({})
        })
      }
    } 

    const setBlockMessages = async() => {
      const matchPath:string = props.match.url.replace(`/${props.match.params.lang}` || '', '')
      let routes:any = matchPath === '/' || !matchPath ? (props.routes || []) : [{path: matchPath}];
      let blocks:any = routes.filter((route:any) => {
        const fileName:any = route.path.replace('/','');
        return fileName !='404';
      });

      Object.keys(messages).map(async(locale:any) => {
        const blocksMessage = await Promise.all(blocks.map(async(block:any) => {
          const blockName:string = block.path.replace('/','');
          const message:any = await getBlockMessage(blockName, locale);
          return message
        }));

        blocksMessage.map((message:any) => {
          messages[locale] = {...messages[locale], ...message}
        });
      })
      return new Promise((resolve:any,reject) => {
        resolve()
      })
    }

    const setModulesConfig = async() => {
      const rootRoute:any = RoutesConfig.find((item:any) => item.path == '/');
      let routes:any = rootRoute.routes || [];
      let modules:any = routes.filter((route:any) => {
        const fileName:any = route.path.replace('/','');
        return fileName !='404';
      });
      
      await Promise.all(modules.map(async(module:any) => {
        const moduleName:string = module.path.replace('/','');
        const moduleConfig:any = await getModulesConfig(moduleName);
        modulesConfig = {...modulesConfig, ...moduleConfig}
      }));
      
      return new Promise((resolve,reject) => {
        resolve(null)
      })
    }

    setModulesConfig()
    .then(() => {
      let acl:any = {}
      Object.keys(modulesConfig).map((key:any) => {
        const moduleAcl:any = modulesConfig[key]?.acl || {};
        acl = {...acl, ...moduleAcl}
      })
      dispatch(GlobalActions.setModuleAcl(acl))
      setModulesSetting(modulesConfig)
    })

    setBlockMessages()
    .then(() =>  setI18nMessages(messages))
  },[])

  return (
    <>
      {
        !i18nMessages[global.locale] &&
        <SkeletonLoading/>
      }
      
      {
        i18nMessages[global.locale] &&
        <ReactRouterContext>
          <IntlProvider locale="en"  messages={Object.keys(Languages).length && i18nMessages[global.locale]}>
            {React.cloneElement(props.children, { RouteComponents, modulesSetting })}
            <Dialog/>
            <Alert/>
            <Snackbar/>
          </IntlProvider>
        </ReactRouterContext>
      }
    </>
  )
}

export default LoadableComponent;